import { createSelector, Selector } from '@reduxjs/toolkit';

import { RootState } from '~/store';

import { NotificationState } from '.';

const selectSelf: Selector<RootState, NotificationState> = state => state.notification;

export const selectOption = createSelector(selectSelf, state => state.option);
